export const PARTNERSHIP_4 = {
    seatCount: 4,
    teams: [
        { id: 0, seats: [0, 2] },
        { id: 1, seats: [1, 3] },
    ],
    teamOf: [0, 1, 0, 1],
};
/** Partnerships of two, partners sitting opposite: seats s and s + n/2. */
export function partnershipTable(seatCount) {
    if (seatCount < 4 || seatCount % 2 !== 0)
        throw new Error(`No partnership table for ${seatCount} seats`);
    const half = seatCount / 2;
    return {
        seatCount,
        teams: Array.from({ length: half }, (_, id) => ({ id, seats: [id, id + half] })),
        teamOf: Array.from({ length: seatCount }, (_, s) => s % half),
    };
}
/** Every player for themselves: one team per seat, team id = seat. Two seats
 *  is head-to-head play; three or more is cutthroat. */
export function individualTable(seatCount) {
    if (seatCount < 2)
        throw new Error(`No table for ${seatCount} seats`);
    return {
        seatCount,
        teams: Array.from({ length: seatCount }, (_, s) => ({ id: s, seats: [s] })),
        teamOf: Array.from({ length: seatCount }, (_, s) => s),
    };
}
export const HEADS_UP_2 = individualTable(2);
export function nextSeat(t, s) {
    return (s + 1) % t.seatCount;
}
export function seatAfter(t, s, steps) {
    return (s + steps) % t.seatCount;
}
export function partnerOf(t, s) {
    const team = t.teams[t.teamOf[s]];
    if (!team || team.seats.length !== 2)
        return null;
    return team.seats[0] === s ? team.seats[1] : team.seats[0];
}
export function sameTeam(t, a, b) {
    return t.teamOf[a] === t.teamOf[b];
}
export function allSeats(t) {
    return Array.from({ length: t.seatCount }, (_, i) => i);
}
/** Next seat that is in `active`, starting after `from`. Used for trick rotation
 *  when a seat sits out (500 misère: the contractor's partner). */
export function nextActiveSeat(t, from, active) {
    for (let i = 1; i <= t.seatCount; i++) {
        const s = seatAfter(t, from, i);
        if (active.includes(s))
            return s;
    }
    return from;
}
//# sourceMappingURL=seats.js.map